import * as z from 'zod/v4';

import { createDateTime, dateTimeSchema } from '../frameworks/entry.js';

export const SessionStoreKey = {
  COUPON_SETTINGS: 'CouponSettings',
  WAGER_SETTINGS: 'WagerSettings',
} as const;

export type SessionStoreKey = (typeof SessionStoreKey)[keyof typeof SessionStoreKey];

export const sessionStoreBaseSchema = z.object({
  data: z.unknown(),
});

export const sessionStoreDataBaseSchema = z.object({
  // Default to current date time for now
  __upd: dateTimeSchema.catch(createDateTime()),
});

export type SessionStoreDataBase = z.infer<typeof sessionStoreDataBaseSchema>;
